import { Methods } from '@newview/infrastructure';
import {BasicDataBaseApi} from "./BasicDataBaseApi";


export class LoginforApi extends BasicDataBaseApi {

  public get ControllerName(): any {
    return 'loginfor'
  }

  /**
   * 分页获取
   * @param params
   */
  public getListPage(params){
    return this.send(params,"getEntitiesPage",Methods.GET)
  }
 
  
 

  
 

}